/*
 * @Author: your name
 * @Date: 2021-01-20 11:06:35
 * @LastEditTime: 2021-05-14 18:22:17
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \vue_admin\src\api\user.js
 */
import request from "@/utils/request";
import { setCookies, getCookies, createToken } from "@/utils/auth";

export function login(data) {
  return request({
    url: "/sys/login/login",
    method: "post",
    data: data
  });
}

/**
 * 获取验证码
 * @returns
 */
export function getCaptcha() {
  var loginToken = createToken();
  setCookies("loginToken", loginToken);
  return request({
    url: "/sys/login/refresh",
    method: "POST",
    data: {
      token: loginToken,
    }
  });
}

export function config(data) {
  return request({
    url: "/sys/login/config",
    method: "POST",
    data: data,
  });
}

export function getInfo(token) {
  return request({
    url: "/sys/login/user/info",
    method: "POST",
    data: { token },
  });
}

export function logout() {
  return request({
    url: "/sys/login/logout",
    method: "post",
  });
}

/**
 * 查询 角色用户菜单权限标签
 */
export function getPermissionsList() {
  return request({
    url: "/sys/login/permissionsList",
    method: "POST",
  });
}

/**
 * 修改密码
 * @param {params}} data
 */
export function updateUsersPassword(data) {
  return request({
    url: "/sys/login/updateUsersPassword",
    method: "POST",
    data: data
  });
}
